import { createReducer, on } from '@ngrx/store';
import { AdminActions, AdminState } from '.';

export const initialState: AdminState = {
  student: null,
};

export const adminReducer = createReducer(
  initialState,
  on(
    AdminActions.setStudentSuccess,
    (state, { student }): AdminState => ({
      student: student,
    })
  ),
  on(AdminActions.clearStudent, (): AdminState => initialState)
);
